module.exports = __webpack_public_path__ + "img/FF_Info_Game_15.8df69d70.png";